/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberStatus } from './WebApiModelsEnumerationTypesMemberStatus';
import {
    WebApiModelsEnumerationTypesMemberStatusFromJSON,
    WebApiModelsEnumerationTypesMemberStatusFromJSONTyped,
    WebApiModelsEnumerationTypesMemberStatusToJSON,
} from './WebApiModelsEnumerationTypesMemberStatus';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoMissingMemberDto
 */
export interface WebApiIntegrationsDtoMissingMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMissingMemberDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMissingMemberDto
     */
    uniqueId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMissingMemberDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMissingMemberDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMissingMemberDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberStatus}
     * @memberof WebApiIntegrationsDtoMissingMemberDto
     */
    status?: WebApiModelsEnumerationTypesMemberStatus;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoMissingMemberDto interface.
 */
export function instanceOfWebApiIntegrationsDtoMissingMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoMissingMemberDtoFromJSON(json: any): WebApiIntegrationsDtoMissingMemberDto {
    return WebApiIntegrationsDtoMissingMemberDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoMissingMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoMissingMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'uniqueId': !exists(json, 'uniqueId') ? undefined : json['uniqueId'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesMemberStatusFromJSON(json['status']),
    };
}

export function WebApiIntegrationsDtoMissingMemberDtoToJSON(value?: WebApiIntegrationsDtoMissingMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'uniqueId': value.uniqueId,
        'fullName': value.fullName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'status': WebApiModelsEnumerationTypesMemberStatusToJSON(value.status),
    };
}

